var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0202 1.97974C14.9518 2.91138 14.9518 4.42187 14.0202 5.35351L6.04132 13.3324C5.85674 13.517 5.62718 13.6502 5.37533 13.7189L1.96487 14.649C1.59163 14.7508 1.24914 14.4083 1.35093 14.0351L2.28106 10.6246C2.34974 10.3728 2.48296 10.1432 2.66755 9.95862L10.6464 1.97974C11.5781 1.0481 13.0886 1.0481 14.0202 1.97974ZM10.0001 4.04034L3.37465 10.6657C3.31312 10.7273 3.26872 10.8038 3.24582 10.8877L2.54593 13.454L5.11222 12.7541C5.19616 12.7312 5.27268 12.6868 5.33421 12.6253L11.9594 5.99967L10.0001 4.04034ZM11.3535 2.68684L10.7068 3.33301L12.6661 5.29301L13.3131 4.6464C13.8542 4.10529 13.8542 3.22796 13.3131 2.68684C12.772 2.14573 11.8947 2.14573 11.3535 2.68684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditWhite);
export default __webpack_public_path__ + "static/media/icon-edit-white.8ce33cad6de8310a7eec56d5372786a1.svg";
export { ForwardRef as ReactComponent };